import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';
import { APP_TEXTS } from '@texts';


export default class InputWithSelect extends React.Component {

  static propTypes = {
    options: PropTypes.array.isRequired,
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ])
  };

  input = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      selectedValue: props.value || props.options[0]
    };
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.value !== this.state.selectedValue) {
      this.setState({
        selectedValue: this.props.value
      });
      this.input.current.value = this.props.value;
    }
  }

  render() {
    return (
      <div className={`select ${this.props.className} w-50 mr-2`}> 
        <select
          className="select__select"
          onChange={this.onChange}>

          {this.props.options.map(i => (
            <option key={i} value={i}>{i}</option>
          ))}
        </select>
        <input
          ref={this.input}
          className="select__input"
          name="displayValue"
          placeholder={APP_TEXTS.GENERAL_CALCULATION_PROFILE_ORIENTATION.Content}/*"Profile orientation" */
          onBlur={this.onChange}
          type="text"
          defaultValue={this.state.selectedValue}
        />
      </div>
    );
  }

  onChange = (e) => {
    this.setState({
      selectedValue: e.target.value
    });

    this.input.current.value = e.target.value;

    this.props.onChange(e.target.value);
  };

}



// WEBPACK FOOTER //
// ./src/components/InputWithSelect/index.js